import { useState } from 'react'

import xor from 'lodash/xor'

type Return = [
  string[],
  (newValue: string | null | undefined) => void,
  (newValues: string[]) => void,
]

const useSelectIds = (initialArray: string[] = []): Return => {
  const [values, setValues] = useState(initialArray)

  const setSelectedValue = (newValue: string | null | undefined) => {
    if (!newValue) {
      setValues([])

      return
    }

    setValues(xor(values, [newValue]))
  }

  const setSelectedValues = (newValues: string[]) => {
    setValues(newValues)
  }

  return [values, setSelectedValue, setSelectedValues]
}

export default useSelectIds
